import React, {CSSProperties, HTMLAttributes} from 'react'

export interface StackProps extends HTMLAttributes<HTMLDivElement> {
    style?: CSSProperties
}

/**
 * Lays out its children below each other (flex column).
 * minWidth/minHeight 0 let it shrink inside other flex layouts instead of overflowing them.
 * For form fields use FormStack, which also adds the form spacing.
 */
const Stack = ({style, children, ...rest}: StackProps) => {
    return (
        <div {...rest} style={{display: 'flex', flexDirection: 'column', minWidth: 0, minHeight: 0, ...style}}>
            {children}
        </div>
    )
}

export default Stack
